/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as TileBadges } from "./TileBadges";
export type { TileBadgesProps } from "./TileBadgesProps";
